/**
 * @generated SignedSource<<47476d176e8065c5a3c42eb70493eb9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StripeHistoryTableRow_userFile$data = {
  readonly createdAt: any;
  readonly meta: any | null;
  readonly " $fragmentType": "StripeHistoryTableRow_userFile";
};
export type StripeHistoryTableRow_userFile$key = {
  readonly " $data"?: StripeHistoryTableRow_userFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"StripeHistoryTableRow_userFile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StripeHistoryTableRow_userFile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meta",
      "storageKey": null
    }
  ],
  "type": "UserFile",
  "abstractKey": null
};

(node as any).hash = "354dc948ddf690518decc26eef4e85c9";

export default node;
